// hooks/useMenuHeight.js - упрощенная версия
import { useState, useEffect } from 'react';

export const useMenuHeight = () => {
    const [menuHeight, setMenuHeight] = useState(110);

    useEffect(() => {
        // Функция для обновления высоты из CSS переменной
        const updateFromCSSVariable = () => {
            const height = getComputedStyle(document.documentElement)
                .getPropertyValue('--menu-height')
                .replace('px', '');
            if (height) {
                setMenuHeight(parseInt(height) + 20);
            }
        };

        // Ищем меню и получаем его высоту напрямую
        const updateFromElement = () => {
            const menu = document.querySelector('.v1_61');
            if (menu) {
                const height = menu.offsetHeight;
                setMenuHeight(height + 20);
            }
        };

        // Периодически проверяем появление меню
        const interval = setInterval(() => {
            const menu = document.querySelector('.v1_61');
            if (menu) {
                updateFromElement();
                clearInterval(interval);
            }
        }, 100);

        // Слушаем событие, которое может генерировать BottomMenu
        window.addEventListener('menu-mounted', updateFromElement);
        window.addEventListener('resize', updateFromElement);

        return () => {
            clearInterval(interval);
            window.removeEventListener('menu-mounted', updateFromElement);
            window.removeEventListener('resize', updateFromElement);
        };
    }, []);

    return menuHeight;
};